import { usePrintTicket } from "./print"

export function useCancelaciones() {
    const { handlePrint } = usePrintTicket()

    const handlePrintTicketOnCancelacion = (ticket_id: string | string[], extras_ids?: string[]) => {
        if (!ticket_id) return

        if (Array.isArray(ticket_id) && ticket_id.length > 0) {
            ticket_id.map((ticket) => {
                // Imprimir ticket tipo “0” al momento de cancelar una venta -> Actualización 10/Jul/2026
                handlePrint(ticket, "original")
            })
        }

        if (extras_ids && extras_ids.length > 0) {
            extras_ids.map((extra_id) => {
                // Imprimir ticket tipo “5” al momento de cancelar un extra pendiente 
                handlePrint(extra_id, "custom", "5")
            })
        }

        if (typeof ticket_id === "string") {
            // Imprimir ticket tipo “1” al momento de cancelar una venta
            handlePrint(ticket_id, "copia")
        }

        return
    }

    return {
        handlePrintTicketOnCancelacion,
    }
}
